module.exports = __webpack_public_path__ + "static/media/Angelou.47c3cccb.png";